import styled from 'styled-components'

export default styled.div`
  font-weight: 500;
  color: ${props => props.color};
`
